<style lang="stylus" scoped>
@import "../cardMap.stylus"
</style>
<template>
        <div class="map-province m-t radius-5">
      <div class="font20">合计</div>
      <div class="map-province-cont">
        <div class="map-province-lib b-t-0" v-for="(it,index) in totalCount" :key='index' :class="it.selected?'map-card-active':''">
          <div class="_lib1">{{handleMapTitle(it.dataType,it.timeSection)}}</div>
          <div class="_lib2">{{it.timeSection}}</div>
          <div class="_lib3">{{initNum(it.count)}}</div>
          <div class="m-t-2 font14">
            <el-row class="color1 font12">
              <el-col :span="4">
                <div class="t-l">个人单卡</div>
              </el-col>
              <el-col :span="8">
                <div class="t-c">个人多卡</div>
              </el-col>
              <el-col :span="8">
                <div class="t-c">企业单卡</div>
              </el-col>
              <el-col :span="4">
                <div class="t-r">企业多卡</div>
              </el-col>
            </el-row>
            <el-row class="m-t font12">
              <el-col :span="4">
                <div class="t-l">{{initNum(it.personalSingleCard)}}</div>
              </el-col>
              <el-col :span="8">
                <div class="t-c">{{initNum(it.personalMoreCard)}}</div>
              </el-col>
              <el-col :span="8">
                <div class="t-c">{{initNum(it.companySingleCard)}}</div>
              </el-col>
              <el-col :span="4">
                <div class="t-r">{{initNum(it.companyMoreCard)}}</div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
    export default {
       props:{
           totalCount:{
               type:[Array,Object],
           }
       }
    }
</script>